import * as IO from "fp-ts/IO";
import * as E from "fp-ts/Either";
import * as O from "fp-ts/Option";
import { pipe } from "fp-ts/function";
import CookiesWithGetJSON from "js-cookie";

/*
 * Helpers
 */

const validateToken = (c: Cookie): E.Either<string, Cookie> => {
    return !/^(r:)[a-z0-9]{32}$/.test(c.token) ? E.left("invalid session token") : E.right(c);
};

const getCookieFromLocalStorage = (name: string): E.Either<string, Cookie> => {
    const cookie: Cookie = CookiesWithGetJSON.getJSON(name);

    return !cookie ? E.left("could not find cookie") : E.right(cookie);
};

/*
 * Main
 */

export const deleteCookie =
    (name: string): IO.IO<O.Option<boolean>> =>
    (): O.Option<boolean> => {
        CookiesWithGetJSON.remove(name);
        return O.some(true);
    };

export const readCookie =
    (name: string): IO.IO<E.Either<string, Cookie>> =>
    (): E.Either<string, Cookie> => {
        return pipe(getCookieFromLocalStorage(name), E.chain(validateToken));
    };

export const saveCookie =
    (name: string, cookie: Cookie): IO.IO<O.Option<string>> =>
    (): O.Option<string> => {
        return O.fromNullable(
            CookiesWithGetJSON.set(name, cookie, {
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                sameSite: "strict",
                secure: process.env.NODE_ENV === "production",
            }),
        );
    };
